import { PrintOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { PrintPutAwayOrderButton } from "../FinalizeCheckInSuccessDialog/components/PrintPutAwayOrderButton"

import { Button } from "@/components/common/Button"
import type { GoodsReceipt, GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface Props {
  selectedCount: number
  goodsReceipt: GoodsReceipt
  pallets: GoodsReceiptPallet[]
  isAkrochemManaged: boolean
  putAwayLoading: boolean
  canMaintain: boolean
  onPutAway: () => void
  onQrPrintAll: () => void
}

export const BuiltPalletsActionButtons: FC<Props> = ({
  selectedCount,
  goodsReceipt,
  pallets,
  isAkrochemManaged,
  putAwayLoading,
  canMaintain,
  onPutAway,
  onQrPrintAll,
}) => {
  if (!isAkrochemManaged) {
    return null
  }

  return (
    <>
      {canMaintain && (
        <>
          <Button
            appearance='contained'
            variant='primary'
            startIcon={<PrintOutlined />}
            onClick={onPutAway}
            data-testid='put-away-button'
            disabled={selectedCount === 0 || putAwayLoading}
          >
            Put Away ({selectedCount})
          </Button>
          <PrintPutAwayOrderButton
            goodsReceipt={goodsReceipt}
            pallets={pallets}
            buttonLabel='Print Put Away Order'
            buttonProps={{
              appearance: "outlined",
              variant: "primary",
              startIcon: <PrintOutlined />,
              "data-testid": "print-put-away-order-button",
            }}
          />
        </>
      )}
      <Button
        appearance='outlined'
        variant='primary'
        startIcon={<PrintOutlined />}
        onClick={onQrPrintAll}
        data-testid='all-qrs-button'
      >
        All QR Codes
      </Button>
    </>
  )
}
